import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect } from "react";
interface Props {
  notification: any;
  isOpen: any;
  onClose: any;
  getData: any;
}
const NotificationDelete: React.FC<Props> = ({
  notification,
  isOpen,
  onClose,
  getData,
}) => {
  // const { _id } = notification;
  // useEffect(() => {
  //     const findCategory = masterCategory.find((val: Record<string, any>) => val._id === _id);

  //     if (!findCategory) {

  //         onClose();
  //     }
  // }, [_id, masterCategory, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Notification</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to delete notification?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            // disabled={busy}
            onClick={() => {
              if (notification._id) {
                axios({
                  method: "delete",
                  url: `${process.env.REACT_APP_BASE_URL}/admin/notification/${notification._id}`,
                })
                  .then((response) => {
                    onClose(); // Optionally close the drawer on submit
                    getData(); // Optionally refresh the data after submit
                  })
                  .catch((error) => {
                    console.error("API Error:", error);
                    onClose();
                  });
              }
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {/* {message && (
                    <ModalFooter>
                        <Alert status="error">
                            <AlertIcon />
                            <AlertTitle mr={2}>{message}</AlertTitle>
                            <CloseButton position="absolute" right="8px" top="8px" />
                        </Alert>
                    </ModalFooter>
                )} */}
      </ModalContent>
    </Modal>
  );
};

export default NotificationDelete;
